import { eventsApi } from '../object-plus/index.js';
import { ItemsBehavior, transactionApi } from '../transactions.js';
const { trigger2, trigger3, on, off } = eventsApi, { commit } = transactionApi, _aquire = transactionApi.aquire, _free = transactionApi.free;
export function dispose(collection) {
    const { models } = collection;
    collection.models = [];
    collection._byId = {};
    freeAll(collection, models);
    return models;
}
export function convertAndAquire(collection, attrs, options) {
    const { model } = collection;
    let record;
    if (collection._shared) {
        record = attrs instanceof model ? attrs : model.create(attrs, options);
        if (collection._shared & ItemsBehavior.listen) {
            on(record, record._changeEventName, collection._onChildrenChange, collection);
        }
    }
    else {
        record = attrs instanceof model ? (options.merge ? attrs.clone() : attrs) : model.create(attrs, options);
        if (record._owner) {
            if (record._owner !== collection) {
                _aquire(collection, record.clone());
                const errors = collection._aggregationError || (collection._aggregationError = []);
                errors.push(record);
            }
        }
        else {
            _aquire(collection, record);
        }
    }
    const { _itemEvents } = collection;
    _itemEvents && _itemEvents.subscribe(collection, record);
    return record;
}
export function free(owner, child, unset) {
    if (owner._shared) {
        if (owner._shared & ItemsBehavior.listen) {
            off(child, child._changeEventName, owner._onChildrenChange, owner);
        }
    }
    else {
        _free(owner, child);
        unset || child.dispose();
    }
    const { _itemEvents } = owner;
    _itemEvents && _itemEvents.unsubscribe(owner, child);
}
export function freeAll(collection, children) {
    for (let child of children) {
        free(collection, child);
    }
    return children;
}
export function sortElements(collection, options) {
    let { _comparator } = collection;
    if (_comparator && options.sort !== false) {
        collection.models.sort(_comparator);
        return true;
    }
    return false;
}
export function addIndex(index, model) {
    index[model.cid] = model;
    var id = model.id;
    if (id || id === 0) {
        index[id] = model;
    }
}
export function removeIndex(index, model) {
    delete index[model.cid];
    var id = model.id;
    if (id || id === 0) {
        delete index[id];
    }
}
export function updateIndex(index, model) {
    delete index[model.previous(model.idAttribute)];
    const { id } = model;
    id == null || (index[id] = model);
}
export class CollectionTransaction {
    constructor(object, isRoot, added, removed, nested, sorted) {
        this.object = object;
        this.isRoot = isRoot;
        this.added = added;
        this.removed = removed;
        this.nested = nested;
        this.sorted = sorted;
    }
    commit(initiator) {
        const { nested, object } = this, { _isDirty } = object;
        for (let transaction of nested) {
            transaction.commit(object);
        }
        if (object._aggregationError) {
            logAggregationError(object, _isDirty);
        }
        for (let transaction of nested) {
            trigger2(object, 'change', transaction.object, _isDirty);
        }
        const { added, removed } = this;
        for (let record of added) {
            trigger3(record, 'add', record, object, _isDirty);
            trigger3(object, 'add', record, object, _isDirty);
        }
        for (let record of removed) {
            trigger3(record, 'remove', record, object, _isDirty);
            trigger3(object, 'remove', record, object, _isDirty);
        }
        if (this.sorted) {
            trigger2(object, 'sort', object, _isDirty);
        }
        if (added.length || removed.length) {
            trigger2(object, 'update', object, _isDirty);
        }
        this.isRoot && commit(object, initiator);
    }
}
export function logAggregationError(collection, options) {
    collection._log('warn', 'Type-R:InvalidOwner', 'added records already have an owner and were cloned. Use explicit record.clone() to dismiss this warning.', collection._aggregationError, options.logger);
    collection._aggregationError = void 0;
}
//# sourceMappingURL=commons.js.map